module.exports = __webpack_public_path__ + "static/media/add-card-union-pay.5d73902e.svg";